import { useTranslate } from 'src/localization/Trns'
import type { StatementDocumentFormat } from 'src/page-components/Accounts/AccountStatementsTab/accountStatementsDemoData'

/**
 * The one place a statement document format gets a human name (EX-40602).
 *
 * Exhaustive over the union rather than defaulted, so adding a contract format
 * fails typecheck here instead of leaking a SCREAMING_SNAKE token onto the page.
 */
export const useStatementDocumentFormatLabels = (): Record<
  StatementDocumentFormat,
  string
> => {
  const translate = useTranslate()

  return {
    PDF: translate('PDF'),
    XLSX: translate('Excel (.xlsx)'),
    CSV: translate('CSV'),
  }
}
